import React from 'react';

import Link from '@atlaskit/link/link';

export default function Inverse(): React.JSX.Element {
	return (
		<Link href="https://www.atlassian.com/software/confluence" appearance="inverse">
			Inverse link
		</Link>
	);
}
